import { createSlice } from "@reduxjs/toolkit";
import { fetchSupervisor } from "./thunk";

interface SupervisorState {
  SupervisorList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: SupervisorState = {
  SupervisorList: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const SupervisorSlice = createSlice({
  name: "Supervisor",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSupervisor.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSupervisor.fulfilled, (state, action) => {
        state.loading = false;
        state.SupervisorList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchSupervisor.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to fetch Supervisor";
      });
  },
});

export default SupervisorSlice.reducer;
